<template>
  <div class="konami">
    <div v-if="isInProductPage" class="image-gradient"></div>
    <div class="container text-center">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          <div v-if="!isInProductPage">
            <i class="icon-star"></i>
            <h3 class="h4 title -upper">{{ content.text }}</h3>
            <p class="-upper">
              {{ $t('Please enter the code to access exclusive content') }}
            </p>
          </div>
          <div v-else>
            <span v-if="content.headline" class="h4 headline">{{
              content.headline
            }}</span>
            <h3 v-if="content.title" class="title -upper">
              {{ content.title }}
            </h3>
            <p v-if="content.text" class="text">{{ content.text }}</p>
          </div>
          <div class="form">
            <base-input
              id="konamiCode"
              type="text"
              name="konamiCode"
              v-model="konamiCode"
              :placeholder="$t('VIP CODE')"
            />
          </div>
          <NoSSR>
            <div
              class="countdown"
              v-if="isInProductPage && countdown && countdown > 0"
            >
              <div class="wrapper" key="count">
                <h2 class="countdown-title" v-text="$t('Coming soon')"></h2>
                <Countdown
                  v-if="countdown && countdown > 0"
                  :time="countdown"
                  tag="div"
                  :transform="transform"
                  @end="onCountdownEnd"
                >
                  <template slot-scope="props">
                    <div class="countdown-digit">
                      <strong>{{ props.days }}</strong
                      >{{ $t('days') }}
                    </div>
                    <div class="countdown-digit">
                      <strong>{{ props.hours }}</strong
                      >{{ $t('hrs') }}
                    </div>
                    <div class="countdown-digit">
                      <strong>{{ props.minutes }}</strong
                      >{{ $t('min') }}
                    </div>
                    <div class="countdown-digit">
                      <strong>{{ props.seconds }}</strong
                      >{{ $t('sec') }}
                    </div>
                  </template>
                </Countdown>
              </div>
            </div>
          </NoSSR>
        </div>
      </div>
    </div>
    <img :src="image" alt="" class="visual" />
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import BaseInput from '../form/BaseInput'
import { mapActions } from 'vuex'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'
import Countdown from '@chenfengyuan/vue-countdown'

export default {
  props: ['konami', 'code', 'countdown', 'isInProductPage'],
  name: 'Konami',
  mixins: [ReadyHook],
  components: {
    BaseInput,
    Countdown,
    NoSSR
  },
  methods: {
    ...mapActions('konami', ['setOverlay']),
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value
        props[key] = `${digits}`
      })
      return props
    },
    onCountdownEnd(){
      this.$bus.$emit('setCountdown', false);
    }
  },
  computed: {
    content() {
      return {
        headline: this.konami && this.konami.headline ? this.konami.headline : '',
        title: this.konami && this.konami.title ? this.konami.title : '',
        text: this.konami && this.konami.text ? this.konami.text : ''
      }
    },
    image() {
      return this.konami && this.konami.image && this.konami.image.url
        ? this.konami.image.url
        : ''
    }
  },
  data() {
    return {
      konamiCode: null
    }
  },
  watch: {
    konamiCode() {
      const isEqual = this.konami.codes.includes(this.konamiCode.toLowerCase())
      if (isEqual) {
        this.setOverlay({ overlay: false });
        this.$bus.$emit('setCountdown', -1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.konami {
  padding: 8rem 0;
  background: var(--zenith-theme-primary);
  color: var(--zenith-white);
  @include bp(max md) {
    padding: 4rem 0 6rem;
  }

  .container {
    position: relative;
    z-index: 10;
  }

  i {
    display: inline-block;
    font-size: em(30);
    margin-bottom: 2rem;
  }

  p {
    font-size: em(16);
    margin-bottom: 2rem;
  }

  .visual {
    max-width: 100%;
    z-index: 5;
    position: relative;
    margin-top: -20rem;
    @include bp(max xl) {
      margin-top: -10rem;
    }
    @include bp(max lg) {
      margin-top: 0;
    }
  }

  .form {
    margin: auto;
    max-width: 20rem;
    margin-bottom: 32px;
  }

  /deep/ .form-line {
    input {
      color: white;
      text-align: center;
      background: transparent;
      border: none;
      border-bottom: 1px solid white;
    }
    label {
      color: white;
      text-align: center;
      background: transparent;
      padding-right: 0;
      width: 100%;
      left: 0;
      right: 0;
    }
    &.-top {
      & > label:not(.btn) {
        width: 100%;
        left: 0;
        right: 0;
        background: transparent;
      }
    }
  }

  .headline {
    display: inline-block;
    margin-bottom: 32px;
  }

  .image-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
    z-index: 6;
  }

  .countdown {
    @include bp(max md) {
      margin-top: 4rem;
    }

    .wrapper > div {
      display: flex;
      justify-content: center;
    }

    &-title {
      margin: 0 0 1rem;
      font-size: em(18);
      font-weight: normal;
      letter-spacing: em(0.2, 18);
      text-transform: uppercase;
    }

    &-digit {
      position: relative;
      width: 8rem;
      font-size: em(16);
      text-transform: uppercase;

      &:not(:last-child):after {
        position: absolute;
        top: 2%;
        right: 0;
        content: ':';
        transform: translateX(50%);
      }

      strong {
        display: block;
        font-size: em(28, 16);
        line-height: em(28, 28);
      }
    }
  }
}
</style>
